import TagGroupItemList, { TagGroupItemListProps } from './TagGroupItemList';

export type { TagGroupItemListProps };
export default TagGroupItemList;
